import React, { Fragment } from 'react';
import { ServiceModel } from '../../../../models/ServiceModel';
import { utcIsoDateToString } from '../../../../utils/date';

interface ServicesProps {
  setActive: (service: ServiceModel) => void;
  editService: (service: ServiceModel) => void;
  onBlur?: any;
  service: ServiceModel;
}

const ServiceElement = ({
  setActive,
  editService,
  onBlur,
  service,
}: ServicesProps) => {
  const toggleActive = () => {
    if (service.typ === undefined || service.typ?.toLowerCase() === 'logisch') {
      service.active = !service.active;
      setActive(service);
    }
  };

  const handleKeyUp = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      toggleActive();
    }
  };

  return (
    <li
      className={
        service.active || (service.wert && service.wert.toLowerCase() != 'null')
          ? service.backgroundColor
            ? service.backgroundColor
            : `bg-indigo400`
          : ''
      }
      title={
        service.bezeichnung +
        (service.typ?.toLowerCase() === 'datum'
          ? service.wert != undefined && service.wert.trim().length > 0
            ? ': ' + utcIsoDateToString(service.wert)
            : ''
          : service.wert
          ? ': ' + service.wert
          : '')
      }
      tabIndex={0}
      onBlur={onBlur && onBlur()}
      onKeyUp={e => handleKeyUp(e)}
    >
      <div
        className={`serviceBezeichnung ${service.hinweis ? 'bold' : ''} ${
          service.active ||
          (service.wert && service.wert.toLowerCase() != 'null')
            ? service.backgroundColor
              ? service.backgroundColor
              : `bg-indigo400`
            : ''
        }`}
        onClick={toggleActive}
      >
        {service.bezeichnung}
      </div>

      {service.editable && editService ? (
        <Fragment>
          <button title='Bearbeiten' onClick={() => editService(service)}>
            <i className='fas fa-pencil-alt'></i>
          </button>
        </Fragment>
      ) : (
        ''
      )}
      {service.active &&
        (service.typ === undefined ||
          service.typ.toLowerCase() === 'logisch') && (
          <Fragment>
            <p>
              <i className='far fa-check-circle'></i>
            </p>
          </Fragment>
        )}
    </li>
  );
};

export default ServiceElement;
